import Stack from "@mui/material/Stack";
import React from "react";

import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import moment from "moment";
export default function ProductBonusFormRow({
  item,
  index,
  handleProductBonusForm,
  productBonusValidation,
  productOptions,
  disabled,
  copyProductBonusFormData,
  removeProductBonusFormData,
  currentDate,
}) {
  const commissionLevelFormRow = React.useMemo(
    () => (
      <Stack key={index} sx={{ my: 2 }} direction={"row"} spacing={2}>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems={"flex-start"}
          sx={{ flex: 7 }}
          spacing={1}
        >
          {item.isDisabled && (
            <SubdirectoryArrowRightIcon color="warning"></SubdirectoryArrowRightIcon>
          )}
          <TextField
            disabled={disabled}
            error={!!productBonusValidation[index]?.nameErr}
            helperText={productBonusValidation[index]?.nameErr}
            sx={{ maxWidth: 200, minWidth: 200, flex: 0.5 }}
            value={item.name}
            id="outlined-basic"
            label="名稱"
            onChange={(event) => {
              handleProductBonusForm(index, "name", event.target.value);
            }}
            variant="outlined"
          />
          <FormControl fullWidth>
            <DatePicker
              disabled={item.isDisabled || disabled}
              id="startDate"
              name="startDate"
              label="開始日期"
              value={item.startDate}
              onChange={(value) => {
                handleProductBonusForm(
                  index,
                  "startDate",
                  moment(value).format("YYYY-MM-DD")
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={{ width: "100%" }}
                  error={!!productBonusValidation[index]?.startDateErr}
                />
              )}
            ></DatePicker>
            <FormHelperText
              error={!!productBonusValidation[index]?.startDateErr}
            >
              {productBonusValidation[index]?.startDateErr}
            </FormHelperText>
          </FormControl>
          <FormControl fullWidth>
            <DatePicker
              disabled={item.isDisabled || disabled}
              id="startDate"
              name="startDate"
              label="結束日期"
              minDate={moment(item.startDate)
                .startOf("month")
                .format("YYYY-MM-DD")}
              value={item.endDate ?? moment(currentDate).endOf("month")}
              onChange={(value) => {
                handleProductBonusForm(
                  index,
                  "endDate",
                  moment(value).format("YYYY-MM-DD")
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={{ width: "100%" }}
                  error={!!productBonusValidation[index]?.endDateErr}
                />
              )}
            ></DatePicker>
            <FormHelperText error={!!productBonusValidation[index]?.endDateErr}>
              {productBonusValidation[index]?.endDateErr}
            </FormHelperText>
          </FormControl>
        </Stack>
        <ProductAutoComplete
          multiple
          disabled={item.isDisabled}
          sx={{ width: 200, flex: 7 }}
          productOptions={productOptions}
          handleOnChange={(value) => {
            handleProductBonusForm(index, "productIds", value);
          }}
          selectedValue={item.productIds ?? []}
          error={!!productBonusValidation[index]?.productIdsErr}
        ></ProductAutoComplete>
        <TextField
          disabled={disabled}
          error={!!productBonusValidation[index]?.minQtyErr}
          helperText={productBonusValidation[index]?.minQtyErr}
          sx={{ maxWidth: 110, minWidth: 110, flex: 0.5 }}
          value={item.minQty}
          type="number"
          id="outlined-basic"
          label="最少目標數量"
          onChange={(event) => {
            handleProductBonusForm(index, "minQty", event.target.value);
          }}
          variant="outlined"
          InputProps={{
            inputProps: {
              min: 0,
            },
            endAdornment: <InputAdornment position="end">件</InputAdornment>,
          }}
        />
        <TextField
          disabled={disabled}
          error={!!productBonusValidation[index]?.maxQtyErr}
          helperText={productBonusValidation[index]?.maxQtyErr}
          sx={{ maxWidth: 110, minWidth: 110, flex: 0.5 }}
          value={item.maxQty}
          type="number"
          id="outlined-basic"
          label="最多目標數量"
          onChange={(event) => {
            handleProductBonusForm(index, "maxQty", event.target.value);
          }}
          variant="outlined"
          InputProps={{
            inputProps: {
              min: 0,
            },
            endAdornment: <InputAdornment position="end">件</InputAdornment>,
          }}
        />
        <TextField
          disabled={disabled}
          error={!!productBonusValidation[index]?.bounsErr}
          helperText={productBonusValidation[index]?.bounsErr}
          sx={{ maxWidth: 180, minWidth: 100, flex: 0.5 }}
          value={item.bouns}
          type="number"
          id="outlined-basic"
          label="獎金金額"
          onChange={(event) => {
            handleProductBonusForm(index, "bouns", event.target.value);
          }}
          variant="outlined"
          InputProps={{
            inputProps: {
              min: 0,
            },
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
        {!disabled && (
          <Stack
            direction={"row"}
            justifyContent="space-between"
            alignItems={"flex-start"}
            sx={{ flex: 1 }}
          >
            <IconButton onClick={() => copyProductBonusFormData(item, index)}>
              <ContentCopyIcon></ContentCopyIcon>
            </IconButton>
            <IconButton
              color="error"
              onClick={() => removeProductBonusFormData(index)}
            >
              <DeleteForeverIcon></DeleteForeverIcon>
            </IconButton>
          </Stack>
        )}
      </Stack>
    ),
    [item, index, removeProductBonusFormData]
  );
  return commissionLevelFormRow;
}
